import React from "react";
import { ReactElement } from "react";
import { KredietHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Table from "../../components/Table";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";
import { Paragraph } from "../../components/Paragraph";
import { getKredietenColumns } from "../Producten/kredieten-kolommen";

type KredietenProps = {
  kredietenHoofdstuk: KredietHoofdstuk;
};

const getKredietenTable = (
  kredietenHoofdstuk: KredietHoofdstuk
): ReactElement => {
  if (
    !kredietenHoofdstuk.kredieten ||
    kredietenHoofdstuk.kredieten.length === 0
  ) {
    return <></>;
  }

  const columns = getKredietenColumns();
  const kredieten = kredietenHoofdstuk.kredieten;

  return (
    <>
      {kredieten.slice(0, 1).map((krediet, index) => (
        <React.Fragment key={`krediet-fragment-${index}`}>
          <div className="break-avoid">
            <Heading text={`Kredieten binnen het advies`} level={3} />
            <Table
              key={`krediet-${index}`}
              columns={columns}
              data={[krediet]}
              id={`kredieten-table-${index}`}
              filterNullAnd0Columns={true}
              rotate
            />
          </div>
        </React.Fragment>
      ))}
      {kredieten.slice(1).map((krediet, index) => (
        <React.Fragment key={`krediet-fragment-${index + 1}`}>
          <Table
            key={`krediet-${index + 1}`}
            columns={columns}
            data={[krediet]}
            id={`kredieten-table-${index + 1}`}
            filterNullAnd0Columns={true}
            rotate
          />
        </React.Fragment>
      ))}
    </>
  );
};

export const KredietenChapter = ({
  kredietenHoofdstuk,
}: KredietenProps): ReactElement => {
  return (
    <Chapter>
      <Paragraph paragraaf={kredietenHoofdstuk.paragrafen?.["p3050607"]} />

      {getKredietenTable(kredietenHoofdstuk)}
    </Chapter>
  );
};
